module.exports = __webpack_public_path__ + "static/media/twilio-logo.94e3a0e3.svg";